import React, { useEffect, useState, useRef } from "react";
import supporttop from './../../../../images/supporttop.png'
import supportbottom from './../../../../images/suportbottom.png'
import N3rveLogo from './../../../../images/N3rveLogo.png'
import InstagramLogo from './../../../../images/instagramlogo.png'
import TwitterLogo from './../../../../images/twitterlogo.png'
import DiscordLogo from './../../../../images/discordlogo.png'
import DiscordIcon from './../../../../images/discordicon.png'


import SubmitFileBox from './../../../../images/submitfilebox.png'
import NavbarTranslate from "./../../../../images/navbar_translate.png"

import EnIcon from "./../../../../images/englishicon.png"
import JapIcon from "./../../../../images/japanicon.png"
import koreaflag from "./../../../../images/koreaflag.png"
import chinaicon from "./../../../../images/chinaicon.png"
import thaiflag from "./../../../../images/thaiflag.png"
import vietflag from "./../../../../images/vietflag.png"
import indoflag from "./../../../../images/indoflag.png"
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"

import Footer from "./../../../Footer/Footer"
import Cookies from 'universal-cookie';
import ReactModal from 'react-modal';
import crossicon from './../../../../images/crossicon.png'
import { Route, Routes, Redirect, Navigate } from 'react-router-dom'
import SupportForm from "./SupportForm";
import SupportDetails from "./SupportDetails";
import SupportList from "./SupportList";
import './Support.css'
import zIndex from "@mui/material/styles/zIndex";
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";

function Support({ nav }) {

  const navigate = useNavigate();


  const { t, i18n } = useTranslation();
  const [infopage, setInfoPage] = useState(false)
  const [submitRequest, setSubmitRequest] = useState(false)
  const [successfulRequest, setSuccessfulRequest] = useState(false)
  const [infopageHeader, setInfoPageHeader] = useState("")
  const location = useLocation()
  const [languagedropdown, setLanguageDropdown] = useState(false)
  const cookies = new Cookies(null, { path: '/' });
  const [LogoutPopup, setLogoutPopup] = useState(false)
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });
  const [signedin, setSignedIn] = useState(false)
  const hasLogged = useRef(false);

  const openInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = false;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/Dashboard", "_blank");
  };

  const openLabelInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = false;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/dashboard/label", "_blank");
  };



  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  useEffect(() => {
    topFunction()
  }, [location.pathname])



  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, [])

  useEffect(() => {
    if (cookies.get('token') !== undefined && cookies.get('staysignedin')) {
      setSignedIn(true)
    } else {
      setSignedIn(false)
    }

    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        console.log("Token present")
        console.log(decodeToken(cookies.get('token')) !== null)
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Help Page", { "desc": "User opened the help page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Help Page", { "desc": "User opened the help page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Help Page", { "desc": "User opened the help page" })
        hasLogged.current = true;
      }
    }
  }, [])



  const handleLogout = () => {
    cookies.set('token', undefined)
    cookies.set('staysignedin', false)
    navigate("/")
  }


  function closeLogoutPopup() {
    setLogoutPopup(false)
  }

  return (
    <div className={dimensions.width >= 1024 ? "supportContainer" : "supportContainerTab"} style={{ minHeight: '100vh', height: 'auto' }}>

      {
        dimensions.width >= 1024 &&
        <div style={{ position: 'fixed', top: 0, display: 'flex', width: '100%', justifyContent: 'center', backgroundImage: 'linear-gradient(180deg, #101014 8.85%, rgba(24, 25, 31, 0.5) 67.19%, rgba(24, 25, 31, 0) 100%)', zIndex: '100' }}>
          <div className="Navbar" style={{ width: '98%' }}>


            <Link to="/" style={{ textDecoration: 'none' }} >
              <img src={N3rveLogo} alt="Nerve Logo" style={{ width: '9.21em', height: '1.65em', marginTop: '1.9em', marginLeft: '1.2em' }} />
            </Link>


            <div className='Navbar-menu'>


              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={languagedropdown ? "Translate-iconactive" : "Translate-icon"} style={{ marginTop: '1.9em', marginRight: '1em' }}>
                  <img src={NavbarTranslate} alt="Translate" style={{ cursor: 'pointer' }} className="Translate-iconimg" onMouseOver={() => setLanguageDropdown(true)} />
                </div>
                {
                  languagedropdown &&
                  <div style={{ backgroundColor: 'transparent', paddingTop: '3em', marginTop: '-2em', cursor: 'pointer' }} onMouseLeave={() => setLanguageDropdown(false)} >
                    <div style={{ backgroundColor: '#1D2024', marginTop: '0.4em', paddingBottom: '0.3em', border: '1px #8C8C8C solid', borderRadius: '8px', paddingTop: '0.3em', paddingBottom: '0.3em', position: 'absolute', top: '3em', marginLeft: '-1em' }} onMouseOver={() => setLanguageDropdown(true)} onMouseLeave={() => setLanguageDropdown(false)}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={EnIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>English</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={JapIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'jp'} className='LanguageOption' onClick={() => { i18next.changeLanguage('jp'); cookies.set('lang', 'jp'); setLanguageDropdown(!languagedropdown) }}>日本語</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={koreaflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>한국어</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={chinaicon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>中文</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={thaiflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>ไทย</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={vietflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Tiếng Việt</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={indoflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Bahasa<br /> Indonesia</div>
                      </div>
                    </div>
                  </div>
                }

              </div>

              {
                signedin &&

                <div className="LogOutTxt" style={{ marginTop: '2.1em', marginLeft: '1em', marginRight: '1em' }} onClick={() => setLogoutPopup(true)}>
                  Log Out
                </div>
              }
              {
                signedin &&
                <div className="NavbarSignupBtn" style={{ marginTop: '1.56em' }} onClick={() => {
                  if (cookies.get('token') !== undefined) {
                    if (decodeToken(cookies.get('token')).info.role === "artist" || decodeToken(cookies.get('token')).info.role === "producer") {
                      openInNewTab()
                    }

                    if (decodeToken(cookies.get('token')).info.role === "label") {
                      openLabelInNewTab()
                    }

                  }

                }}>
                  Dashboard
                  <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px' }} />
                </div>

              }




            </div>
          </div>
        </div>
      }

      {
        dimensions.width < 1024 && dimensions.width >= 768 &&
        <div style={{ position: 'fixed', top: 0, display: 'flex', width: '100%', justifyContent: 'center', backgroundImage: 'linear-gradient(180deg, #101014 8.85%, rgba(24, 25, 31, 0.5) 67.19%, rgba(24, 25, 31, 0) 100%)', zIndex: '100' }}>
          <div className="Navbar" style={{ width: '98%' }}>


            <Link to="/" style={{ textDecoration: 'none' }} >
              <img src={N3rveLogo} alt="Nerve Logo" style={{ width: '9.21em', height: '1.65em', marginTop: '1.9em', marginLeft: '1.2em' }} />
            </Link>


            <div className='Navbar-menu'>


              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={languagedropdown ? "Translate-iconactive" : "Translate-icon"} style={{ marginTop: '1.9em', marginRight: '1em' }}>
                  <img src={NavbarTranslate} alt="Translate" style={{ cursor: 'pointer' }} className="Translate-iconimg" onMouseOver={() => setLanguageDropdown(true)} />
                </div>
                {
                  languagedropdown &&
                  <div style={{ backgroundColor: 'transparent', paddingTop: '3em', marginTop: '-2em', cursor: 'pointer' }} onMouseLeave={() => setLanguageDropdown(false)} >
                    <div style={{ backgroundColor: '#1D2024', marginTop: '0.4em', paddingBottom: '0.3em', border: '1px #8C8C8C solid', borderRadius: '8px', paddingTop: '0.3em', paddingBottom: '0.3em', position: 'absolute', top: '3em', marginLeft: '-1em' }} onMouseOver={() => setLanguageDropdown(true)} onMouseLeave={() => setLanguageDropdown(false)}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={EnIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>English</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={JapIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'jp'} className='LanguageOption' onClick={() => { i18next.changeLanguage('jp'); cookies.set('lang', 'jp'); setLanguageDropdown(!languagedropdown) }}>日本語</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={koreaflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>한국어</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={chinaicon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>中文</div>
                      </div>


                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={thaiflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>ไทย</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={vietflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Tiếng Việt</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={indoflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Bahasa<br /> Indonesia</div>
                      </div>
                    </div>
                  </div>
                }

              </div>

              {
                signedin &&

                <div className="LogOutTxt" style={{ marginTop: '2.1em', marginLeft: '1em', marginRight: '1em' }} onClick={() => setLogoutPopup(true)}>
                  Log Out
                </div>



              }

              {
                signedin &&



                <div className="NavbarSignupBtn" style={{ marginTop: '1.56em' }} onClick={() => {
                  if (cookies.get('token') !== undefined) {
                    if (decodeToken(cookies.get('token')).info.role === "artist" || decodeToken(cookies.get('token')).info.role === "producer") {
                      openInNewTab()
                    }

                    if (decodeToken(cookies.get('token')).info.role === "label") {
                      openLabelInNewTab()
                    }

                  }

                }}>
                  Dashboard
                  <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px' }} />
                </div>

              }



            </div>
          </div>
        </div>
      }

      {
        dimensions.width < 768 &&
        <div style={{ position: 'fixed', top: 0, display: 'flex', width: '100%', justifyContent: 'center', backgroundImage: 'linear-gradient(180deg, #101014 8.85%, rgba(24, 25, 31, 0.5) 67.19%, rgba(24, 25, 31, 0) 100%)', zIndex: '100' }}>
          <div className="Navbar" style={{ width: '98%' }}>


            <Link to="/" style={{ textDecoration: 'none' }} >
              <img src={N3rveLogo} alt="Nerve Logo" style={{ width: '6.21em', height: '1.65em', marginTop: '1.9em', marginLeft: '1em' }} />
            </Link>


            <div className='Navbar-menu'>


              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={languagedropdown ? "Translate-iconactive" : "Translate-icon"} style={{ marginTop: '1.9em', marginRight: '1em' }}>
                  <img src={NavbarTranslate} alt="Translate" style={{ cursor: 'pointer' }} className="Translate-iconimg" onMouseOver={() => setLanguageDropdown(true)} />
                </div>
                {
                  languagedropdown &&
                  <div style={{ backgroundColor: 'transparent', paddingTop: '3em', marginTop: '-2em', cursor: 'pointer' }} onMouseLeave={() => setLanguageDropdown(false)} >
                    <div style={{ backgroundColor: '#1D2024', marginTop: '0.4em', paddingBottom: '0.3em', border: '1px #8C8C8C solid', borderRadius: '8px', paddingTop: '0.3em', paddingBottom: '0.3em', position: 'absolute', top: '3em', marginLeft: '-1.8em' }} onMouseOver={() => setLanguageDropdown(true)} onMouseLeave={() => setLanguageDropdown(false)}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={EnIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>English</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={JapIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'jp'} className='LanguageOption' onClick={() => { i18next.changeLanguage('jp'); cookies.set('lang', 'jp'); setLanguageDropdown(!languagedropdown) }}>日本語</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={koreaflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>한국어</div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }} className='HoverLang'>
                        <img src={chinaicon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>中文</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={thaiflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>ไทย</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={vietflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Tiếng Việt</div>
                      </div>

                      <div className='HoverLang' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: '0.5em', paddingRight: '0.5em', paddingTop: '0.2em', paddingBottom: '0.2em' }}>
                        <img src={indoflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                        <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguageDropdown(!languagedropdown) }}>Bahasa<br /> Indonesia</div>
                      </div>
                    </div>
                  </div>
                }

              </div>

              {
                signedin &&
                <div className="LogOutTxt" style={{ marginTop: '2.1em', marginLeft: '0.5em', marginRight: '2em' }} onClick={() => setLogoutPopup(true)}>
                  Log Out
                </div>
              }

              {
                signedin &&
                <div className="NavbarSignupBtn" style={{ marginTop: '1.56em', marginLeft: '-1em' }} onClick={() => {
                  if (cookies.get('token') !== undefined) {
                    if (decodeToken(cookies.get('token')).info.role === "artist" || decodeToken(cookies.get('token')).info.role === "producer") {
                      openInNewTab()
                    }

                    if (decodeToken(cookies.get('token')).info.role === "label") {
                      openLabelInNewTab()
                    }

                  }

                }}>
                  Dashboard
                  <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px' }} />
                </div>

              }



            </div>
          </div>
        </div>
      }



      <Routes>
        <Route exact path="/" element={<SupportList infopageHeader={infopageHeader} setInfoPageHeader={setInfoPageHeader} />} />
        <Route exact path="/info" element={<SupportDetails infopageHeader={infopageHeader} setInfoPageHeader={setInfoPageHeader} />} />
        <Route exact path="/form" element={<SupportForm />} />
      </Routes>

      <Footer />

      {/* <div style={{
            paddingBottom:'1em',
            width:'100%',
            backgroundColor:'#000000',
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
          }}>

                <div 
                style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    marginTop:'1.5em'
                }}>
                    <div className="FooterLink">
                        Privacy Policy
                    </div>

                    <div className="FooterLink">
                        Terms of Services
                    </div>

                    </div>
     
                <div 
                style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    justifyContent:'center',
                    paddingBottom:'2em',
                    paddingTop:'2em'
                }}>
                    <img src={N3rveLogo} alt="Nerve Logo" className='Logo' style={{marginTop:'0em',marginBottom:'0em'}}/>

                    <img src={InstagramLogo} alt="Instagram Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'2.5em'}}/>
                    <img src={TwitterLogo} alt="Twitter Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/>
                    <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><img src={DiscordLogo} alt="Discord Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/></a>
                  
            
                    <div className='Copywrighttext'>&copy; 2023 N3RVE All Rights Reserved</div>
                
                  </div>
        </div> */}






      <ReactModal
        overlayClassName="Overlay"
        isOpen={LogoutPopup}
        contentLabel="Example Modal"
        onRequestClose={closeLogoutPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '42.125em',
            height: '9.81em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)',
          }
        }}
      >
        <div className='LogoutPopupHeader'>
          {t('Areyousureyouwant')}
        </div>
        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => setLogoutPopup(false)} />
        <div style={{ display: 'flex', alignSelf: 'flex-end' }}>
          <div className='CancelBtn' onClick={() => setLogoutPopup(false)}>
            {t('Cancel')}
          </div>
          <div className='LogoutBtn' onClick={() => handleLogout()}>
            {t('Logoutpop')}
            <div className="PostLoginBtnOverlay" />
          </div>
        </div>
      </ReactModal>

    </div>

  );
}

export default Support;